import { useEffect } from 'react';
import { useCities } from './store';

/** Предоставляет загруженные города для фильтра списка. */
export const useCityFilterOptions = () => {
    const getCities = useCities((state) => state.getCities);
    const cities = useCities((state) => state.cities);
    const loading = useCities((state) => state.loading);

    useEffect(() => {
        void getCities();
    }, [getCities]);

    return {
        cities,
        loading
    };
};
